const mapData = {
    cords: [
        {
            "lat": 13.032362,
            "lng": 77.581172
        },
        {
            "lat": 13.031456,
            "lng": 77.582771
        },
        {
            "lat": 13.031624,
            "lng": 77.584991
        },
        {
            "lat": 13.031475,
            "lng": 77.587823
        },
        {
            "lat": 13.029461,
            "lng": 77.587670
        },
        {
            "lat": 13.027690,
            "lng": 77.587153
        },
        {
            "lat": 13.024949,
            "lng": 77.586196
        },
        {
            "lat": 13.025079,
            "lng": 77.585584
        },
        {
            "lat": 13.023961,
            "lng": 77.584129
        },
        {
            "lat": 13.024539,
            "lng": 77.583134
        },
        {
            "lat": 13.024725,
            "lng": 77.581909
        },
        {
            "lat": 13.024967,
            "lng": 77.581029
        },
        {
            "lat": 13.026739,
            "lng": 77.581699
        },
        {
            "lat": 13.029424,
            "lng": 77.583919
        },
        {
            "lat": 13.032362,
            "lng": 77.581172
        },
    ],
    alertLoc: {
        start: {
            "lat": 13.032362,
            "lng": 77.581172
        },
        stop: {
            "lat": 13.024967,
            "lng": 77.581029
        },
        steps: [
            {
                id: 1,
                type: 'red',
                position: {
                    "lat": 13.031624,
                    "lng": 77.584991
                },
                info: {
                    area: 'Sanjay nagar, Bangalore',
                    warning: 'Forward Collision Warning'
                }
            },
            {
                id: 2,
                type: 'green',
                position: {
                    "lat": 13.029461,
                    "lng": 77.587670
                },
                info: {
                    area: 'BEL Road, Bangalore',
                    warning: 'Lane Departure Warning - Right'
                }
            },
            {
                id: 3,
                type: 'red',
                position: {
                    "lat": 13.027690,
                    "lng": 77.587153
                },
                info: {
                    area: 'Vasanth nagar, Bangalore',
                    warning: 'Stressed'
                }
            },
            {
                id: 4,
                type: 'org',
                position: {
                    "lat": 13.025079,
                    "lng": 77.585584
                },
                info: {
                    area: 'ESI Ring Road, Hosur,',
                    warning: 'Hard Braking'
                }
            },
            {
                id: 5,
                type: 'org',
                position: {
                    "lat": 13.024539,
                    "lng": 77.583134
                },
                info: {
                    area: 'Double Road, Bangalore',
                    warning: 'Hard Braking'
                }
            },
        ]
    }
}

export default mapData;
